export default __webpack_public_path__ + "static/media/chuseok51.13561cd5.jpg";